import { createFileRoute, Outlet } from '@tanstack/react-router'
import useRouteLog from '../../hooks/useRouteLog'
import { Layout } from 'antd'
import AdminSider from '../../../views/Admin/AdminSider/AdminSider'
import { css } from '@emotion/css'
import { useEnvironment } from '@strac/react-client-environment'
import { APIProvider } from '@vis.gl/react-google-maps'
import MapSettingsContextProvider from '../../../contexts/MapSettingsContext/MapSettingsContextProvider'
import React from 'react'
import { adminAuth } from '../../hooks/beforeLoad/adminAuth'
import LoadingScreen from '../../LoadingScreen/LoadingScreen'
import { generateRandomString } from '../../utils'
import { getAllData } from '../../../utils/data'

const { Content } = Layout

export const Route = createFileRoute('/admin/_layout')({
  beforeLoad: adminAuth,
  component: RouteComponent,
  pendingComponent: () => <LoadingScreen />,
  loader: async ({ context }) => {
    const rsg = generateRandomString()
    const label = `/admin/_layout/index.tsx loader: ${rsg}`
    console.time(label)

    const { queryClient, client } = context

    const vehiclesQuery = {}
    const vehicles = await queryClient.ensureQueryData({
      queryKey: ['vehicle', 'find', vehiclesQuery],
      queryFn: () => getAllData(client, 'vehicle', vehiclesQuery)
    })

    const allowedAgencies = vehicles.map((vehicle: any) => vehicle.agency_id)

    const vehicleVehicleLocationsQuery = {
      allowed_agencies: allowedAgencies,
      timeframe: '1_month'
    }

    const vehicleVehicleLocations = await queryClient.ensureQueryData({
      queryKey: ['vehicle-vehicle-location', 'find', vehicleVehicleLocationsQuery],
      queryFn: () =>
        client.service('vehicle-vehicle-location').find({
          query: vehicleVehicleLocationsQuery
        }),
      gcTime: 0,
      staleTime: 0
    })

    const agencyIds = [...new Set(vehicles.map((vehicle: any) => vehicle.agency_id))]

    console.timeEnd(label)

    return {
      vehicles: vehicleVehicleLocations.vehicles,
      vehicleLocations: vehicleVehicleLocations.vehicle_locations,
      agencyIds
    }
  }
})

function RouteComponent() {
  const { REACT_APP_GOOGLE_MAPS_API_KEY } = useEnvironment()
  const onLoad = () => {
    console.log('@vis.gl: Google Maps API loaded, version:', google.maps.version)
  }
  useRouteLog('/admin/_layout')
  return (
    <APIProvider apiKey={REACT_APP_GOOGLE_MAPS_API_KEY || ''} onLoad={onLoad}>
      <MapSettingsContextProvider>
        <Layout
          className={css`
            height: 100vh;
          `}
        >
          <Layout hasSider={true}>
            <AdminSider />
            <Content style={{ position: 'relative', overflow: 'auto' }}>
              <Outlet />
            </Content>
          </Layout>
        </Layout>
      </MapSettingsContextProvider>
    </APIProvider>
  )
}
